<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer">
    <small class="flex cursor-pointer">
      <span>{{ title }}</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
    </small>
    <vs-dropdown-menu class="w-32">
      <vs-dropdown-item
        :color="'danger'"
        v-for="(option, index) in options"
        :key="index"
        @click="handleClick(option)"
        >{{ option.value }}</vs-dropdown-item
      >
    </vs-dropdown-menu>
    <vs-dropdown-menu class="w-32">
      <vs-dropdown-item
        @click="
          listeners.timeDurationChanged
            ? {
                timeDurationChanged: listeners.timeDurationChanged()
              }
            : null
        "
        >Type</vs-dropdown-item
      >
      <vs-dropdown-item
        @click="
          listeners.timeDurationChanged
            ? {
                timeDurationChanged: listeners.timeDurationChanged(1)
              }
            : null
        "
        >SubType</vs-dropdown-item
      >
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  data() {
    return {
      title: "Types",
      options: [
        {
          key: "0",
          value: "Types"
        },
        {
          key: "1",
          value: "Sub Types"
        }
      ]
    };
  },
  methods: {
    handleClick(time) {
      this.title = time.value;
      this.$listeners.timeDurationChanged(time.key);
    }
  }
};
</script>
